import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-empty-component',
  // We need the div here as we use the AppEmptyComponent in the test is
  // order to detect if this empty component is rendered (since there's nothing
  // on screen)
  template: '<div class="AppEmptyComponent"></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppEmptyComponent {}
